import { logger } from '../../common/logger';
import { ErrorObject } from 'src/common/types';

const getErrorMessage = (
  message: string | Event,
  source: string | undefined,
  lineno: number | undefined,
  colno: number | undefined,
  error: Error | undefined
) => {
  if (typeof message !== 'string') message = typeof message;

  const errorMessage = `message: ${message}, source: ${source}, line: ${lineno}, column: ${colno}, error: ${error}`;
  return errorMessage;
};

export const handleError = ({
  message,
  source,
  lineno,
  colno,
  error,
}: ErrorObject) => {
  const errorMessage = getErrorMessage(message, source, lineno, colno, error);

  logger.error(errorMessage);
  window.elasticApm.captureError(errorMessage);

  window.yleLeanback.originalWindowOnError?.(
    message,
    source,
    lineno,
    colno,
    error
  );
};

export const logAndClearErrorStack = () => {
  const errorStack = window.yleLeanback.errorStack;

  if (errorStack && errorStack.length > 0) {
    logger.debug('errors from server');
    errorStack.forEach(errorObject => {
      handleError(errorObject);
    });

    window.yleLeanback.errorStack = [];
  }
};
